import { flattenToAppURL } from '@plone/volto/helpers';
import { getUnitItems } from '@redturtle/volto-io-studio/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { NoResults } from '@redturtle/volto-io-studio/components/';
import { Tab, TabList, Tabs } from 'react-aria-components';

import { useLocation, Link } from 'react-router-dom';
import queryString from 'query-string';
import StructureDiagram from './StructureDiagram';
import StructureList from './StructureList';
import { Container } from 'semantic-ui-react';

const View = (props) => {
  const { data } = props;
  const dispatch = useDispatch();

  const navroot = useSelector(
    (state) => state.content.data?.['@components']?.navroot,
  );
  const items = useSelector((state) => state.unitItems?.result?.units);
  const loading = useSelector((state) => state.unitItems?.loadingResults);
  const hasError = useSelector((state) => state.unitItems?.hasError);
  const error = useSelector((state) => state.unitItems?.error);
  const ordinamenti = useSelector(
    (state) => state.unitItems?.result?.ordinamenti,
  );

  const query = queryString.parse(useLocation().search);
  const [currentAA, setCurrentAA] = React.useState();

  useEffect(() => {
    navroot?.navroot &&
      dispatch(
        getUnitItems(flattenToAppURL(navroot.navroot['@id']), currentAA),
      );
  }, [dispatch, navroot, currentAA]);

  // useEffect(() => {
  //   if (ordinamenti && !currentAA) {
  //     setCurrentAA(Object.keys(ordinamenti).toReversed()[0]);
  //   }
  // }, [ordinamenti, currentAA]);

  useEffect(() => {
    if (query.aa) {
      setCurrentAA(query.aa);
    } else if (items) {
      items?.[0]?.units[0]?.aa &&
        setCurrentAA(items?.[0]?.units[0]?.aa.toString());
    }
  }, [items, query.aa]);

  // const changeOrdinamento = (aa) => {
  //   dispatch(getUnitItems(flattenToAppURL(navroot.navroot['@id']), aa));
  //   // setCurrentAA(aa);
  // };

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    if (typeof window !== 'undefined') {
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', checkScreenSize);
      }
    };
  }, []);

  return (
    <Container className="structure">
      {/* <pre>{JSON.stringify(ordinamenti, null, 2)}</pre> */}
      {/* XXX: questi dati potrebbero essere già presenti nel content/blocco */}

      {ordinamenti && (
        <Tabs
          orientation={isSmallScreen ? 'vertical' : 'horizontal'}
          style={{ opacity: loading ? 0.5 : 1 }}
          selectedKey={currentAA}
        >
          <TabList data-orientation="vertical">
            {Object.keys(ordinamenti)
              .toReversed()
              .map((aa, i) => (
                <Tab key={aa} id={aa}>
                  <div>
                    <Link to={`?aa=${aa}`}>{`${aa}/${parseInt(aa) + 1}`}</Link>
                  </div>
                </Tab>
              ))}
          </TabList>
        </Tabs>
      )}
      {/* <pre>{JSON.stringify(items, null, 2)}</pre> */}

      {hasError && <div>Errore {JSON.stringify(error, null, 2)}</div>}
      {!hasError && items && data?.variant === 'diagram' && (
        <StructureDiagram
          isSmallScreen={isSmallScreen ? 'vertical' : 'horizontal'}
          items={items}
        />
      )}
      {!hasError && items && data?.variant === 'list' && (
        <StructureList items={items} />
      )}
    </Container>
    // <div className={cx('faculty-block full-width ', className)}>
    //   <Container>
    //     {data?.title && <h2 className="title">{data?.title}</h2>}
    //     {items && items.length > 0 ? (
    //       <div className={cx('faculty-wrapper', data.column + '-columns')}>
    //         {items?.map((item) => (
    //           <FacultyCard item={item} />
    //         ))}
    //       </div>
    //     ) : (
    //       <NoResults />
    //     )}
    //   </Container>
    // </div>
  );
};

View.propTypes = {};

export default View;
